const sectionCode = "SPRO2";
const chartCode = "C070a";

import { Procedures } from "modules/provider/shared/procedure-charts";

function T70Procedures() {
  return <Procedures chartCode={chartCode} sectionCode={sectionCode} />;
}

export { T70Procedures };
